export default {
  components: {
    findOutMore: {
      freeDessert: 'Dessert gratuito',
      freeDessertNextVisit: 'Dessert gratuito alla tua prossima visita',
      iWorkHard: 'Lavoro duramente per rendere il tuo tempo il più piacevole possibile, siete pregati di valutare il mio servizio',
      weAlwaysWantToDoBetter: 'Vogliamo sempre fare meglio, per favore attendere mentre prepariamo le tue domande di feedback',
      weJustNeedOneMinuteOfYourTime: 'Ci serve solo 1 minuto del tuo tempo',
      youWillBeAskedAFewQuestions: 'Ti verranno poste alcune domande sulla tua esperienza',
      yourFeedbackWillGoDirectlyToMe: 'Il tuo feedback verrà inviato direttamente a me'
    }
  }
};